const warn = () => {
  console.warn('This is not qiankun environment');
};

class GlobalMonitor {
  // æ¯å¦æ¯ qiankun ç¯å¢
  isqiankun: boolean;
  constructor() {
    this.isqiankun = !!(window as any).__POWERED_BY_QIANKUN__;
    if (!(window as any).$qiankun) {
      (window as any).$qiankun = {
        on: this.on,
        emit: this.emit,
        off: this.off,
      };
    } else {
      const { on, emit, off } = (window as any).$qiankun;
      this.on = on;
      this.emit = emit;
      this.off = off;
    }
  }
  /**
   * æ³¨åå¨å±äºä»¶
   * @param _name äºä»¶åç§°
   * @param _cb æ³¨åçäºä»¶
   */
  on(_name: string, _cb): void {
    warn();
  }
  /**
   * åºåå¨å±äºä»¶
   * @param _name äºä»¶åç§°
   * @param _args äºä»¶åæ°
   */
  emit(_name: string, ..._args: any[]): any {
    warn();
  }
  /**
   * å é¤å¨å±äºä»¶
   * @param _name äºä»¶åç§°
   * @param _cb æ³¨åçäºä»¶
   */
  off(_name: string, _cb?): void {
    warn();
  }
}
export let globalMonitor = null;
export function initGlobalMonitor() {
  globalMonitor = new GlobalMonitor();
}
